








import DevNavBar          from "@/components/DevNavBar.vue";
import LoadingIndicator   from "@/components/LoadingIndicator.vue";
import { NavRouteItem }   from "@/types";
import { Component, Vue } from "vue-property-decorator";

@Component({
      name      : "App",
      components: {
          LoadingIndicator,
          DevNavBar
      }
  })
  export default class App
      extends Vue {

  showDevBar = process.env.NODE_ENV!=="production";
      public devNavItems: NavRouteItem[] = [
          {
              location: {
                  path: "/"
              },
              exact   : true,
              name    : "Home"
          },
          {
              location: {
                  name: "Privacy"
              },
              name    : "Privacy"
          },
          {
              location: {
                name: "Overview"
              },
            name      : "Manage"
          },
        {
          location: {
            name: "Login"
          },
          name    : "Login"
        },
        {
          location: {
            path: "/unite/Sample"
          },
          name    : "Sample Event"
        },
        {
          location: {
            path: "/unite/DemoEvent"
          },
          name    : "Demo Event"
        },
        {
          location: {
            name: "PluginTest"
          },
          name    : "PluginTest"
        }
      ];
  }

